import useAdsLogic from "@/hooks/ads/useAdsLogic";
import type { ReactNode } from "react";

interface AdsLogicWrapperProps {
    children: ReactNode;
    placeHolder?: ReactNode;
}

const AdsLogicWrapper = ({ children, placeHolder }: AdsLogicWrapperProps) => {
    const { shouldShowAds } = useAdsLogic();
    return shouldShowAds ? <>{children}</> : <>{placeHolder ?? null}</>;
};

export default AdsLogicWrapper;
